import { useMemo } from 'react'

import { Alert, AlertProps } from '@mantine/core'
import { IconAlertCircle, IconAlertTriangle } from '@tabler/icons-react'

type LXAlertProps = {
  title: string
  type: 'warning' | 'error'
  children: string | JSX.Element
  variant?: AlertProps['variant']
  isFixed?: boolean
}

export const LXAlert = ({ title, type, children, variant, isFixed = false }: LXAlertProps) => {
  const params = useMemo(() => {
    switch (type) {
      case 'warning':
        return {
          color: 'orange',
          icon: <IconAlertTriangle size={16} />,
        }
      case 'error':
        return {
          color: 'red',
          icon: <IconAlertCircle size={16} />,
        }
      default:
        return { color: 'white', icon: '' }
    }
  }, [type])

  return (
    <Alert
      title={title}
      color={params.color}
      icon={params.icon}
      variant={variant}
      style={
        isFixed
          ? {
              position: 'fixed',
              display: 'block',
              bottom: 0,
              right: 0,
              minWidth: '20rem',
            }
          : {}
      }
    >
      {children}
    </Alert>
  )
}
